<template lang="pug">
ul.menu.d-flex.i_h6
  //- li(v-if="false")
  li
    router-link(tag="a", :to="{ name: 'CustomerServiceContactUs' }")
      svg-icon(iconClass="contact", className="icon contact")
    .d-none.d-lg-block.i_mt_1 {{ quickLinks[2] }}
  li
    router-link(tag="a", :to="{ name: 'Location' }")
      svg-icon(iconClass="location", className="icon location")
    .d-none.d-lg-block.i_mt_1 {{ quickLinks[1] }}
  li
    router-link(tag="a", :to="{ name: 'Search' }")
      svg-icon(iconClass="search", className="icon search")
    .d-none.d-lg-block.i_mt_1 {{ quickLinks[3] }}
  li.more_btn(:class="{ expand: moreExpand }", @click="menuExpand")
    svg-icon(:iconClass="moreExpand ? 'close' : 'menu'", className="icon menu")
    .d-none.d-lg-block.i_mt_1.w-100.text-center(:class="[moreExpand ? 'd-block' : 'd-none']") {{ moreExpand ? quickLinks[0][1] : quickLinks[0][0] }}
</template>

<script>
export default {
  name: "Links",
  props: {
    isMoreExpand: Boolean,
  },
  data() {
    return {
      moreExpand: this.isMoreExpand,
      quickLinks: [["更多", "收合"], "服務據點", "聯絡我們", "關鍵搜尋"],
    };
  },
  watch: {
    isMoreExpand() {
      this.moreExpand = this.isMoreExpand;
    },
  },
  methods: {
    menuExpand() {
      this.moreExpand = !this.moreExpand;
      this.$emit("menuExpand", this.moreExpand);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/footer/menu";
</style>
